module.exports = __webpack_public_path__ + "static/media/MassEditPreview.1bc54ab9.png";